/**
 * store search condition of issue saved
 */
const issueSearch = null;
const savedIssueList = null;

const state = {
  searchIssueSavedCondition: issueSearch,
  savedIssueList: savedIssueList,
  savedListErrorUps: null
};
const getters = {
  searchIssueSavedCondition: state => state.searchIssueSavedCondition,
  savedIssueList: state => state.savedIssueList,
  savedListErrorUps: state => state.savedListErrorUps
};

const mutations = {
  changeSearchIssueSaved(state, searchIssue) {
    if (!searchIssue) {
      return;
    }
    if (searchIssue.searchIssueSavedCondition) {
      state.searchIssueSavedCondition = searchIssue.searchIssueSavedCondition;
    }
    if (searchIssue.savedIssueList) {
      state.savedIssueList = searchIssue.savedIssueList;
      state.savedListErrorUps = null;
    }
  },
  clearSearchIssueSaved(state, deleteSearchConditionFlg) {
    if (deleteSearchConditionFlg) {
      state.searchIssueSavedCondition = null;
    }
    state.savedIssueList = null;
    state.savedListErrorUps = null;
  },
  saveSavedListErrorUps(state, listErrorUps) {
    state.savedListErrorUps = listErrorUps;
  }
};

export default {
  state,
  getters,
  mutations
};
